import axios from "axios";
import store from "../store";

const base = axios.create({
  baseURL: process.env.VUE_APP_API_HOST
});

const UNAUTHORIZED = 401;
base.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      error.response = {
        status: 500,
        statusText: error
      };
      throw error;
    }

    // 認証エラー時はJWTをクリアしてリトライ
    if (error.response.status === UNAUTHORIZED) {
      store.commit("resetTwitterAccount");
      store.commit("logout");
      // JWTを指定しない状態にセット
      error.config.headers["Authorization"] = "Bearer ";
      error.config.baseURL = process.env.VUE_APP_API_HOST;
      return axios.request(error.config);
    }
    throw error;
  }
);

export default base;
